import React from 'react'
import { navigate } from 'gatsby'
import Autosuggest from 'react-autosuggest'
import { liteClient } from 'algoliasearch/lite'
import { Configure, Highlight, InstantSearch, connectAutoComplete } from 'react-instantsearch-dom'

const searchClient = liteClient(process.env.GATSBY_ALGOLIA_APPLICATION_ID, process.env.GATSBY_ALGOLIA_SEARCH_KEY)

const App = () => (
  <InstantSearch searchClient={searchClient} indexName='netlify_929d474f-e271-4a4f-a081-940944f7cff8_master_all'>
    <AutoComplete />
    <Configure hitsPerPage={5} />
  </InstantSearch>
)

class Hits extends React.Component {
  constructor(props) {
    super(props)
    this.state = { value: '', hits: [] }
  }

  componentWillReceiveProps(props) {
    this.setState({ hits: props.hits })
  }
  render() {
    const { refine } = this.props
    return (
      <div className='page-block--search'>
        <Autosuggest
          suggestions={this.state.hits}
          multiSection={false}
          focusInputOnSuggestionClick={false}
          onSuggestionsFetchRequested={({ value }) => refine(value)}
          onSuggestionsClearRequested={() => this.setState({ hits: [] })}
          onSuggestionSelected={(evt, { suggestion }) => {
            evt.preventDefault()
            navigate(suggestion.url)
          }}
          getSuggestionValue={(hit) => hit.title}
          renderSuggestion={(hit) => {
            return (
              <div className='hit'>
                {hit.image !== 'https://weekendsherpa.com/weekendsherpa-og.jpeg' ? (
                  <img src={hit.image} alt='' width='60px' height='60px' />
                ) : (
                  <img src='https://ucarecdn.com/3367c041-8d0f-4ab8-96d9-5f686f13c84e/-/scale_crop/300x300/smart/' alt='' width='60px' height='60px' />
                )}
                <div>
                  <div className='key-result'>
                    <Highlight attribute='title' hit={hit} />
                  </div>
                  <small className='sub-result'>
                    <Highlight attribute='description' hit={hit} />
                  </small>
                </div>
              </div>
            )
          }}
          inputProps={{
            placeholder: 'search adventures',
            'aria-label': 'Search the Weekend Sherpa content',
            value: this.state.value,
            onChange: (event, { newValue, method }) => {
              this.setState({ value: newValue })
            }
          }}
          renderSectionTitle={(section) => section.index}
          getSectionSuggestions={(section) => section.hits}
        />
      </div>
    )
  }
}

const AutoComplete = connectAutoComplete(Hits)

export default React.memo(App)
